import styled from 'styled-components';

export const OptionRow = styled.div<{ options: number; }>`
  gap: 4px;
  display: grid;
  grid-template-columns: repeat(${({ options }) => options}, 1fr);
`;
